export const formatAmount = (amount) => {
  const formattedAmount = new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency: "NGN", // You can change the currency code as needed
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
  return formattedAmount;
};


export const hotelsPaymentLink = "https://guest.roomability.io/WOSAMARENAAGOIWOYEOGUNSTATENIGER/step1";